import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/demand/deals')({
  component: DealsLayout,
});

function DealsLayout() {
  return <Outlet />;
}
